import { AxiosResponse } from 'axios';

import { api } from '../http';
import { DefaultRes } from '../types';
import {
    NotificationAlertType,
    RoutingOverview,
} from '../types/notification-rules.types';

const uri = 'notification-rules';

/**
 * Alert Notifications v2.
 *
 * Every routing explanation in the Safety Hub comes from these calls. Nothing
 * here reconstructs routing logic client-side: if the product needs to say
 * something new about who gets notified, the API says it.
 */
export class NotificationRulesService {

    /** Everything the Notifications page renders. */
    public static async fetchOverview(): Promise<RoutingOverview> {
        const { data } = await api.get<DefaultRes<RoutingOverview>, AxiosResponse<DefaultRes<RoutingOverview>>>(uri);
        return data.result;
    }

    public static async updateRule(
        alertType: NotificationAlertType,
        patch: { teamRouting?: boolean; recipientIds?: string[]; stages?: string[] },
    ): Promise<void> {
        await api.put(`${uri}/${alertType}`, patch);
    }

    /** Pass null to clear it, which puts the org back on the admin fallback. */
    public static async setPointOfContact(userId: string | null): Promise<RoutingOverview> {
        const { data } = await api.put<DefaultRes<RoutingOverview>, AxiosResponse<DefaultRes<RoutingOverview>>>(
            `${uri}/point-of-contact`,
            { userId },
        );
        return data.result;
    }

    /**
     * Notify On Dispatch contacts. They still live on the customer settings
     * document; the API routes this through the ordinary settings update so
     * catalog validation and the legacy v1 mirror are not duplicated.
     */
    public static async updateDispatchContacts(
        patch: { enabled?: boolean; phones?: string[]; emails?: string[] },
    ): Promise<RoutingOverview> {
        const { data } = await api.put<DefaultRes<RoutingOverview>, AxiosResponse<DefaultRes<RoutingOverview>>>(
            `${uri}/dispatch-contacts`,
            patch,
        );
        return data.result;
    }
}
